import { Link } from "react-router-dom";

export default function BlogStrip({ blog }) {
  if (!blog.length) return null;
  return (
    <section className="section-pad">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <p className="eyebrow">Learn</p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl text-forest leading-tight">From the Gurukul journal.</h2>
          </div>
          <Link to="/blog" data-testid="blog-see-all" className="text-sm text-clay font-medium hover:underline">All articles →</Link>
        </div>

        <div className="mt-10 md:mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {blog.slice(0, 3).map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group rounded-3xl overflow-hidden border border-sand-300 bg-white hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap gap-2">
                  {p.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-xs px-2 py-1 rounded-full bg-sand-200 text-forest">{tag}</span>
                  ))}
                </div>
                <h3 className="mt-3 font-serif text-xl md:text-2xl text-forest group-hover:text-clay transition-colors leading-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-ink-soft line-clamp-2">{p.excerpt}</p>
                <div className="mt-4 text-xs text-ink-muted">{new Date(p.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })} · {p.read_time}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
